import {
    URLAPI,
    TEAMS_PATH,
    TEAM_CREATE_PATH,
    USERS_TEAMS_CREATE_PATH,
    USERS_TEAMS_DELETE_PATH,
    TEAM_UPDATE_PATH,
} from "../config/index";
import {LOGOUT} from './users'
import axios from "axios";

const init = {
    _get_all_teams: {
        data: [],
        status: 0,
        message: {},
    },
    _create_team: {
        data: {},
        status: 0,
        message: {},
    },
    _create_users_teams: {
        data: {},
        status: 0,
        message: {},
    },
    _delete_users_teams: {
        data: {},
        status: 0,
        message: {},
    },
    _update_team: {
        data: {},
        status: 0,
        message: {},
    },
};

const GET_ALL_TEAMS = "GET_ALL_TEAMS";
export const CREATE_TEAM = "CREATE_TEAM";
export const CREATE_USERS_TEAMS = "CREATE_USERS_TEAMS";
export const DELETE_USERS_TEAMS = "DELETE_USERS_TEAMS";
export const UPDATE_TEAM = "UPDATE_TEAM";

export const teams_module = (state = init, action) => {
    switch (action.type) {
        case GET_ALL_TEAMS:
            return {
                ...state,
                _get_all_teams: action.payload,
            };
        case CREATE_TEAM:
            return {
                ...state,
                _create_team: action.payload,
            };
        case CREATE_USERS_TEAMS:
            return {
                ...state,
                _create_users_teams: action.payload,
            };
        case DELETE_USERS_TEAMS:
            return {
                ...state,
                _delete_users_teams: action.payload,
            };
        case UPDATE_TEAM:
            return {
                ...state,
                _update_team: action.payload,
            };
        case LOGOUT:
            return init;
        default:
            return state;
    }
};

export const getAllTeams = (token) => async (dispatch) => {
    try {
        const response = await axios.get(`${URLAPI}${TEAMS_PATH}`, {
            headers: {
                Authorization: `Basic ${token}`,
            },
        });
        dispatch({
            type: GET_ALL_TEAMS,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: GET_ALL_TEAMS,
                payload: {
                    data: [],
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: GET_ALL_TEAMS,
                payload: {
                    data: [],
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

export const createTeam = (token, data) => async (dispatch) => {
    try {
        let form = new FormData();

        for (var key in data) {
            form.append(key, data[key]);
        }
        const response = await axios.post(
            `${URLAPI}${TEAM_CREATE_PATH}`,
            form,
            {
                headers: {
                    Authorization: `Basic ${token}`,
                },
            }
        );
        dispatch({
            type: CREATE_TEAM,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: CREATE_TEAM,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: CREATE_TEAM,
                payload: {
                    data: {},
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

export const createUsersTeams = (token, id, data) => async (dispatch) => {
    try {
        let form = new FormData();

        for (var key in data) {
            if (key !== 'usuarios') {
                form.append(key, data[key]);
            } else {
                form.append(key, JSON.stringify(data[key]));
            }
        }
        const response = await axios.post(
            `${URLAPI}${USERS_TEAMS_CREATE_PATH}${id}/`,
            form,
            {
                headers: {
                    Authorization: `Basic ${token}`,
                },
            }
        );
        dispatch({
            type: CREATE_USERS_TEAMS,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: CREATE_USERS_TEAMS,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: CREATE_USERS_TEAMS,
                payload: {
                    data: {},
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

export const deleteUsersTeams = (token, id_team, id_user) => async (dispatch) => {
    try {
        const response = await axios.delete(`${URLAPI}${USERS_TEAMS_DELETE_PATH}${id_team}/${id_user}/`,
            {
                headers: {
                    Authorization: `Basic ${token}`,
                },
            }
        );
        dispatch({
            type: DELETE_USERS_TEAMS,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: DELETE_USERS_TEAMS,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: DELETE_USERS_TEAMS,
                payload: {
                    data: {},
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

export const updateTeam = (token, id, data) => async (dispatch) => {
    try {
        let form = new FormData();

        for (var key in data) {
            form.append(key, data[key]);
        }
        const response = await axios.patch(
            `${URLAPI}${TEAM_UPDATE_PATH}${id}/`,
            form,
            {
                headers: {
                    Authorization: `Basic ${token}`,
                },
            }
        );
        dispatch({
            type: UPDATE_TEAM,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: UPDATE_TEAM,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: UPDATE_TEAM,
                payload: {
                    data: {},
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

export const clear_teams = (type) => async (dispatch) => {
    dispatch({
        type: type,
        payload: {
            data: [],
            status: 0,
            message: {},
        },
    });
};
